module.exports = __webpack_public_path__ + "static/media/epy_advise.b0b6e58d.svg";